import type { Schema } from '@tix/openapi-sdk'
import { TixTimeOfDay } from '@tix/tix-time'

type PickNPromptOption = NonNullable<NonNullable<Schema<'action_prompt_pick_n'>['options']>['options']>[number]

/** Includes `card_title` before the OpenAPI schema catches up — see `PickNAction`. */
export type PickNOptionLabelSource = PickNPromptOption & {
  meta?: (PickNPromptOption['meta'] & { card_title?: string }) | undefined
}

export type PickTimeOption = NonNullable<NonNullable<Schema<'action_prompt_pick_time'>['options']>['times']>[number]

/** User-visible `pick_n` card label — shared with analytics formatters. */
export function getPickNOptionDisplayName(option: PickNOptionLabelSource): string {
  return option.meta?.card_title || option.name
}

/** User-visible `pick_time` card label — shared with analytics formatters. */
export function getPickTimeDisplayName(time: PickTimeOption): string {
  return new TixTimeOfDay(time.start).format('h:mm A')
}
